// MainPage.tsx
import React, { useEffect,useState } from 'react';
import Project from '../../Items/Project';
import './MainPage.css';
import JobsList from '../../components/JobsTable/JobsTable';
import Logo from '../../assets/images/Logo.png'
import { useDispatch } from 'react-redux';
import { getBusinesses } from '../../Services/BusinessService';

const Header = () => {
   return (
    <header className="header">
      <section className="logo-section">
       <img src={Logo} alt="Logo"/>
      </section>
      
 
      <div className="main-link" style={{ marginRight:'2%'}}>ראשי</div>
    </header>
  );
};


const MainPage: React.FC = () => {
const [projects, setProjects] = useState<Project[]>([
 {
      id: 1,
      OrderingCompany: 'Amdocs',
      workType: 'פיתוח',
      price: '1000',
      fileRecovery: 'קובץ1.pdf',
      status: 'פתח קובץ',
      progress: null,
      completed: false,
      statusType: 'gray'
    },
    {
      id: 2,
      OrderingCompany: 'מכבי',
      workType: 'בריאות',
      price: '2500',
      fileRecovery: 'קובץ2.pdf',
      status: 'פתח קובץ',
      progress: 75,
      completed: false,
      statusType: 'blue'
    },
    {
      id: 3,
      OrderingCompany: 'קווים',
      workType: 'תחבורה',
      price: '1800',
      fileRecovery: 'קובץ3.pdf',
      status: 'פתח קובץ',
      progress: null,
      completed: true,
      statusType: 'purple'
    }
  ]);
  const dispatch = useDispatch<any>();
  const addNewProject = (): void => {
    console.log("addNewProject"); // 👈 תוסיפי את זה!
    const newProject: Project = {
      id: Date.now(),
      OrderingCompany: '',
      workType: '',
      price: '',
      fileRecovery: '',
      status: 'פתח קובץ',
      progress: null,
      completed: false,
      statusType: 'purple',
      isNew:true,
    };
      setProjects([newProject, ...projects]);  };
 useEffect(() => {
    dispatch(getBusinesses()); 
  }, [dispatch]);

  return (
    <div className="main-page"> 
      <Header/>
      <button onClick={()=>addNewProject()} className='plusJobBtn' ><span> + </span>עבודה חדשה</button>
      <JobsList projects={projects} setProjects={setProjects} />
    </div>
  );
};

export default MainPage;